import { Popover as MantinePopover } from "@mantine/core";
import React from "react";

import { defaults } from "./Menu";

const Popover: typeof MantinePopover = (props) => {
  return (
    <MantinePopover withinPortal {...defaults} {...props}>
      {props.children}
    </MantinePopover>
  );
};

Popover.Dropdown = MantinePopover.Dropdown;
Popover.Target = MantinePopover.Target;
Popover.displayName = MantinePopover.displayName;

export { Popover };
